(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multi-column"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ma-multi-carousel')) {
  customElements.define('ma-multi-carousel', class extends HTMLElement {
    connectedCallback() {
      // Defer until children are parsed, including theme-editor section reloads.
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      this.track = this.querySelector('.ma-carousel-track');
      if (!this.track) return;
      this.controls = this.querySelector('.ma-carousel-controls');
      this.prev = this.querySelector('[data-ma-prev]');
      this.next = this.querySelector('[data-ma-next]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.desktop = matchMedia('(min-width: 999px)');
      const update = () => this.update();
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', update, { ...options, passive: true });
      this.desktop.addEventListener('change', update, options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !this.isCarouselActive()) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }
      }, options);
      this.addEventListener('shopify:block:select', event => {
        if (!this.isCarouselActive()) return;
        const item = event.target.closest('.multi-column__item');
        if (!item || !this.contains(item)) return;
        const viewport = this.track.getBoundingClientRect();
        const bounds = item.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({ left: rtl ? bounds.right - viewport.right : bounds.left - viewport.left, behavior: 'instant' });
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(this.track);
      for (const item of this.track.children) this.observer.observe(item);
      this.update();
    }
    isCarouselActive() {
      return this.desktop.matches || this.dataset.mobileCarousel === 'true';
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      this.controls.hidden = !this.isCarouselActive() || max <= 2;
      this.prev.disabled = position <= 2;
      this.next.disabled = position >= max - 2;
    }
    move(direction) {
      if (!this.isCarouselActive()) return;
      const first = this.track.firstElementChild;
      if (!first) return;
      const style = getComputedStyle(this.track);
      const step = first.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
      this.track.scrollBy({
        left: step * direction * (style.direction === 'rtl' ? -1 : 1),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
